export const wellbeing = {
  main_title: "Mående",
  happy: "Bra",
  neutral: "Neutral",
  sad: "Dåligt",
  legend_info: "{1} svar ({2} %)",
  calendar_info: "Klicka på dag för att se detaljer",
  no_entries: "Inga registreringar",
};
